import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { checkIsAuthenticated } from '../../../../utils/authUtils';
import { setLoginFirstModalOpen } from '../../../store/slices/common/commonSlice';
import Button from '../../Common/Button';
import LoginFirstModal from '../../Common/LoginFirstModal/LoginFirstModal';

const ActionBtn = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { city } = router?.query;
  const lang = useSelector(({ common }) => common?.language);
  const showCommunityButton = () => {
    if (
      router?.pathname !== '/community/start-discussion' &&
      router?.pathname?.includes('/community')
    ) {
      return true;
    }
    return false;
  };
  const showMarketButton = () => {
    if (
      router?.pathname !== '/market/place-ad' &&
      router?.pathname?.includes('/market')
    ) {
      return true;
    }
    return false;
  };
  const handleClick = () => {
    if (
      checkIsAuthenticated() &&
      router?.pathname !== '/community/start-discussion' &&
      router?.pathname?.includes('/community')
    ) {
      router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/community/start-discussion?city=${city}`
      );
    } else if (
      checkIsAuthenticated() &&
      router?.pathname !== '/market/place-ad' &&
      router?.pathname?.includes('/market')
    ) {
      router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/market/place-ad?city=${city}`
      );
    } else {
      dispatch(setLoginFirstModalOpen(true));
    }
  };

  return (
    <>
      {showMarketButton() ? (
        <Button className='h-[42px]' onClick={handleClick}>
          {' '}
          {lang?.common?.place_ad}
        </Button>
      ) : showCommunityButton() ? (
        <Button className='h-[42px]' onClick={handleClick}>
          {' '}
          {lang?.common?.start_new_discussion}
        </Button>
      ) : (
        null
      )}
      <LoginFirstModal />
    </>
  );
};

export default ActionBtn;
